import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '_store';
import { AppThemeProvider } from 'theme';

import { App } from './App';
import '@fontsource/material-symbols-outlined';
import './index.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <AuthProvider>
                <AppThemeProvider>
                    <App />
                </AppThemeProvider>
            </AuthProvider>
        </BrowserRouter>
    </React.StrictMode>
);
